import React, { useRef, useState } from 'react';
import { Container, Row } from "react-bootstrap";
import BeneficiaryCard from "./BeneficiaryCard";
import BeneficiaryHeader, { BeneficiariesCarouselBtns } from "./BeneficiaryHeader";
import testimonyData from "../../../../assets/data/beneficiary-testimony/testimony";
import Carousel from "react-multi-carousel";




export default function Beneficiaries() {

  const carouselRef = useRef<any>(null);
  const [carouselState, ] = useState({ currentSlide: 0 });  // State to track carousel status

  // Handlers for next, previous, and goToSlide
  const next = () => carouselRef?.current?.next();
  const previous = () => carouselRef?.current?.previous();
  const goToSlide = (slideIndex: any) => carouselRef?.current?.goToSlide(slideIndex);

  const testimonialData = testimonyData();

  const responsive = {
    largeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1200, min: 992 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 992, min: 768 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
  };

  return (
    <section
      id="beneficiaries"
      className="section beneficiaries"
      style={{
        margin: "80px auto"
      }}
    >
      <Container>
        <BeneficiaryHeader />

        <Row>
          <Carousel
            responsive={responsive}
            ref={carouselRef}
            infinite={true}
            autoPlay={true}
            arrows={false}
            renderButtonGroupOutside={true}
            ssr={true}
            swipeable={true}
            keyBoardControl={true}
            showDots={false}
            containerClass="carousel-container"
            itemClass="carousel-item-padding-40-px"
            customButtonGroup={
              <BeneficiariesCarouselBtns
                next={next}
                previous={previous}
                goToSlide={goToSlide}
                carouselState={carouselState}
              />
            }
          >
            {testimonialData.map((testimony) => (
              <div key={testimony.id}
                className="beneficiary-carousel-card"
              >
                <BeneficiaryCard
                  name={testimony.name}
                  imgSrc={testimony.imgSrc}
                  testimony={testimony.testimony}
                  role={testimony.role}
                />
              </div>
            ))}
          </Carousel>
        </Row>
      </Container>
    </section>
  );
}
